import styled from 'styled-components'

import mediaQueries from 'components/media-queries'
import e2eClasses from 'helpers/automation'

const getTarget = url => {
  return url.includes('http') ? '_blank' : '_self'
}

export const Container = styled.div.attrs(() => ({
  className: e2eClasses('home.promotion.cardBox')
}))`
  position: relative;
  display: flex;
  align-items: center;
  max-width: 1200px;
  justify-content: space-between;
  width: 100%;

  ${mediaQueries.tablet`
    flex-direction: column;
  `};
`
export const Wrapper = styled.div.attrs(props => ({
  role: props.role,
  'aria-roledescription': 'carousel'
}))`
  display: block;
  width: 100%;
  max-width: ${({ hasHighlighted, cards }) =>
    cards <= 5 ? `calc(${cards} * 130px)` : hasHighlighted ? '650px' : '780px'};
  margin: 0 40px;

  ${mediaQueries.tablet`
    max-width: ${({ cards }) => (cards < 4 ? `calc(${cards} * 130px)` : '520px')};
    margin: 25px 40px;

    ${mediaQueries.mobile`
      max-width: ${({ cards }) => (cards === 1 ? `130px` : '260px')};
    `};
  `};
`
export const Title = styled.label.attrs(() => ({
  className: e2eClasses('home.promotion.cardTitle')
}))`
  font-family: ${({ theme }) => theme.fonts.semiBold};
  color: ${({ theme }) => theme.colors.doveGray};
  font-size: 18px;
  display: flex;
  align-items: center;

  ${mediaQueries.tablet`
    margin-bottom: 8px;
  `};
`
export const Card = styled.a.attrs(({ url, dataPosition }) => {
  const attrs = {
    className: e2eClasses('home.promotion.cardItem'),
    'data-posición': dataPosition
  }
  if (url) {
    attrs.href = url
    attrs.target = getTarget(url)
  }
  return attrs
})`
  margin: ${({ highlighted }) => (highlighted ? '0 10px 2px 20px' : '0 10px 2px 10px;')};
  width: ${({ highlighted }) => (highlighted ? '140px' : '110px')};
  height: 60px;
  display: flex;
  border-radius: 3px;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 2px 4px 0 ${({ theme }) => theme.shadow.black26};

  ${mediaQueries.tablet`
    margin: 0 10px 2px 10px;
  `};

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.black};
  }
`
export const LinkTag = styled.a.attrs(() => ({
  className: e2eClasses('home.promotion.linkBank')
}))`
  display: flex;
  color: ${({ theme }) => theme.colors.blue};
  font-family: ${({ theme }) => theme.fonts.regular};
`
export const CardContainer = styled.div`
  width: 100%;
`
export const Arrow = styled.div.attrs(() => ({
  className: e2eClasses('home.promotion.arrowIcon')
}))`
  &:before {
    display: none;
  }
`
export const Image = styled.img`
  max-height: 51px;
  max-width: ${({ highlighted }) => (highlighted ? '128px' : '98px')};
`
export const BackgroundContainer = styled.div`
  width: 100%;
  height: 100px;
  align-items: center;
  justify-content: center;
  display: flex;
  background-color: ${({ theme }) => theme.colors.paleGray};

  ${mediaQueries.tablet`
    height: 300px;
  `};
`
